<script>
	import { mapState, mapGetters } from "vuex";
	import i18n from "@/i18n";

	export default {
		props: {
			dataAsProps: {
				type: Object,
				required: false,
				default: undefined
			},
			sectionId: {
				type: Number,
				required: true
			},
			index: {
				type: Number,
				required: true
			},
			lineNumber: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				title: "",
				...this.dataAsProps
			};
		},
		computed: {
			...mapGetters(["enabledHeaders"]),
			...mapState({
				table: state => state.billing.table,
				dynamicColspan: state => state.billing.dynamicColspan,
				background: state => state.settings.accentColor.background,
				headers: state => state.billing.headers
			})
		},
		watch: {
			$data: {
				handler(newValue) {
					this.$emit("update:dataAsProps", newValue);
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			/**
			 * request the parent for the deletion of this component
			 * @param {{String , Number}} parameter recivied parameter of the trigger event
			 */
			async remove(sectionId, index) {
				if (this.table.sections.length === 1) {
					this.$emit("event-remove", { sectionId, index });
				} else {
					const message = this.$createElement('div', [
						this.$createElement('p', { class: 'mb-2' }, i18n.t("La suppression d’une section entraîne la suppression définitive de toutes les Lignes et Commentaires qu’elle contient.")),
						this.$createElement('p', { class: 'mb-0' }, i18n.t("Voulez-vous supprimer cette section ?"))
					]);

					const response = await this.$bvModal.msgBoxConfirm(message, {
						title: i18n.t("Confirmer la suppression"),
						size: "sm",
						buttonSize: "sm",
						okVariant: "danger",
						okTitle: i18n.t("Oui"),
						cancelTitle: i18n.t("Non"),
						footerClass: "p-2",
						hideHeaderClose: true,
						centered: true
					});

					if (response === true) {
						this.$emit("event-remove", { sectionId });
					}
				}
			}
		}
	};
</script>

<template>
	<Fragment>
		<b-td 
			v-if="enabledHeaders.line_number" 
			class="billing__cell"
		>
			<b-form-input
				v-model.lazy="lineNumber"
				:placeholder="$t('Titre de la section')"
				class="billing__input billing_section_input"
				:autofocus="true"
				:style="{ 
					'border-left-color': `${background} !important`, 
					'background-color': 'transparent'
				}"
				disabled
			/>
		</b-td>
		<b-td
			:colspan="headers.line_number.enabled ? (dynamicColspan - 1) : dynamicColspan"
			class="billing_section_cell position-relative"
		>
			<b-form-input
			v-model.lazy="title"
			:placeholder="$t('Titre de la section')"
			class="billing__input billing_section_input"
			:autofocus="true"
			:style="{
				'border-left': headers.line_number.enabled ? '0 !important' : `5px solid ${background} !important`
			}"
			/>
			<div class="icon_container">
			<b-icon
				icon="x"
				class="sinao-clickable sinao-section-icon-trash"
				@click="remove(sectionId, index)"
			/>
			</div>
		</b-td>
	</Fragment>
</template>

<style scoped lang="scss">
	@import "../../scss/mixins";

	.icon_container {
		position: absolute;
		right: 0;
		top: 0;
		height: 100%;
		// display: flex;
		// align-items: center;
		width: 1.7em;
	}

	.sinao-section-icon-trash {
		color: #ccc;
		padding: 0;
		width: 100%;
		height: 100%;
	}

	.billing_section {
		&_cell {
			padding: 0;
		}
		&_input {
			border-left: 5px solid rgb(66, 133, 244) !important;

			&:focus {
				border-left: 5px solid rgb(66, 133, 244) !important;
			}
		}
	}

	.sinao-clickable {
		cursor: pointer;
	}
</style>
